import { useQuery } from '@tanstack/react-query'
import { brandingApi } from '../services/api/branding'
import { Branding } from '../types/branding'

export function useOrgBranding(orgId: string | undefined): {
  branding: Branding | null
  loading: boolean
} {
  const { data, isFetching } = useQuery({
    queryKey: ['org-branding', orgId],
    queryFn: () => brandingApi.getForOrg(orgId!),
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000,
  })

  return {
    branding: data ?? null,
    loading: isFetching,
  }
}
